import { Footer, Stepper } from '@containers/layout'
import { BaseLayout } from '@shared/layout/core'

import { AlreadyHaveAccount } from '../../containers'

export interface SignupSandboxLayoutProps {
  /**
   * React Node Children.
   */
  children?: React.ReactNode
}

export const SignupSandboxLayout: React.FC<SignupSandboxLayoutProps> = ({
  children,
}) => {
  return (
    <BaseLayout className="grid-rows-[auto_min-content]">
      <Stepper
        className="relative h-full pt-20 font-circular sm:pt-0"
        hideBackground
      >
        <div className="fixed top-0 z-30 w-full bg-white sm:relative">
          <Stepper.Header hideBackBtn />
          <AlreadyHaveAccount className="absolute right-6 top-6 hidden justify-end lg:block" />
        </div>
        {children}
      </Stepper>
      <Footer />
    </BaseLayout>
  )
}
